import "./polyfill";
import "picturefill";
import jquery from "jquery";

// needed to set the path for Images used in JS files.
// import was required to set the value before the other imports.
import "./assetsDirectory.js";

// component JS helpers
import initHeroVideoBanner from "./components/HeroV2VideoBanner/initHeroV2VideoBanner.js";
import initHeroSlider from "./components/HeroSlider/initHeroSlider.js";
import initHeroVideo from "./components/HeroVideo/initHeroVideo.js";
import initAccordionHorizontal from "./components/AccordionHorizontal/initAccordionHorizontal.js";
import initAccordionVertical from "./components/AccordionVertical/initAccordionVertical";
import initBackToTop from "./components/BackToTop/initBackToTop.js";
import initCarousel from "./components/Carousel/initCarousel.js";
import initContainer from "./components/Container/initContainer.js";
import initContentList from "./components/ContentList/initContentList.js";
import initFeaturedPromo from "./components/FeaturedPromo/initFeaturedPromo.js";
import initGlobalHeader from "./components/GlobalHeader/initGlobalHeader.js";
import initListItem from "./components/ListItem/initListItem.js";
import initNewsletterSignup from "./components/GlobalFooter/initNewsletterSignup.js";
import initPromo from "./components/Promo/initPromo.js";
import initRichText from "./components/RichText/initRichText.js";
import initSectionNavigator from "./components/SectionNavigator/initSectionNavigator.js";
import initSiteHeader from "./components/SiteHeader/initSiteHeader.js";
import initShareBar from "./components/ShareBar/initShareBar.js";
import initSkipNavigation from "./components/SkipNavigation/initSkipNavigation.js";
import initSlideShow from "./components/Slideshow/initSlideShow.js";
import initTestimonals from "./components/Testimonial/initTestimonals.js";
import initSiteLogo from "./components/SiteLogo/initSiteLogo.js";
import initAlertBanner from "./components/AlertBanner/initAlertBanner.js";
import initScFormsValidation from "./components/FormItems/initScFormsValidation.js";

// React Apps
import renderAnchorLinkNavigation from "./components/AnchorLinkNavigation/renderAnchorLinkNavigation.jsx";
import renderDynamicContentListing from "./components/DynamicContentListing/renderDynamicContentListing.jsx";
import renderYouTubeVideo from "./components/YouTubeVideo/renderYouTubeVideo.jsx";

// Search Apps
import { createApp } from "./search/factory";
import { defaultFacetedSearchFactory } from "./search";

// This is required to make Storybook run JS when patterns are choosen
document.addEventListener("DOMContentLoaded", () => {
  initHeroVideoBanner();
  initHeroSlider();
  initHeroVideo();
  initAccordionHorizontal();
  initCarousel();
  initContainer();
  initContentList();
  initFeaturedPromo();
  initGlobalHeader();
  initNewsletterSignup();
  initListItem();
  initRichText();
  initSectionNavigator();
  initAccordionVertical();
  initShareBar();
  initSiteHeader();
  initSkipNavigation();
  initSlideShow();
  initPromo();
  initBackToTop();
  initTestimonals();
  initSiteLogo();
  initAlertBanner();
  initScFormsValidation();

  // react Apps
  renderAnchorLinkNavigation();
  renderDynamicContentListing();
  renderYouTubeVideo();

  // Search Apps
  // only init if results are included
  document.querySelectorAll(".js-search-results").forEach((el, i) => {
    const searchId = el.dataset.searchId;
    const searchApp = createApp(defaultFacetedSearchFactory(searchId));
    searchApp();
  });

  // Google Tag Manager requires jquery
  window.jQuery = window.jQuery || jquery;
});

window.addEventListener("load", () => {});
